// TestimonioCard.jsx
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';





const TestimonioCard = ({ caso, descripcion, urlPdf }) => {

  console.log(`[TestimonioCard] Renderizando. Recibí la URL: ${urlPdf}`);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const [scale, setScale] = useState(1.0);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div className="testimonio-card">
      {/* Lado Izquierdo: Descripción y Reseña */}
      <div className="resena-lado">
        <h3 className="caso-titulo">Caso: {caso}</h3>
        <ul className="caso-descripcion-lista">
          {descripcion.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <p className="lectura-indicacion">
          **Desliza el PDF al lado para ver el detalle de la resolución.**
        </p>
      </div>

      {/* Lado Derecho: Visor PDF */}
      <div className="pdf-visor-lado">
        <h4 className="pdf-titulo">Resolución Judicial (Detalle)</h4>
        
        <div className="controles-pdf">
          <button onClick={() => setScale(s => Math.max(s - 0.2, 0.6))} disabled={scale <= 0.6}>-</button>
          <span>Zoom: {(scale * 100).toFixed(0)}%</span>
          <button onClick={() => setScale(s => Math.min(s + 0.2, 2.0))} disabled={scale >= 2.0}>+</button>
        </div>

        <div className="visor-contenedor">
          <Document
            file={urlPdf} // URL o ruta de tu archivo PDF
            onLoadSuccess={onDocumentLoadSuccess}
            loading="Cargando Documento..."
            noData="No se pudo cargar el PDF."
          >
            {/* Solo muestra la primera página (o puedes hacer un loop para todas) */}
            <Page pageNumber={pageNumber} renderTextLayer={true} renderAnnotationLayer={true} scale={scale} />
            
          </Document>
          {numPages && (
            <p className="pdf-paginacion">Página {pageNumber} de {numPages}</p>
          )}
        </div>

        {/* Opcional: Botones de navegación si necesitas ver más de una página. */}
        {numPages > 1 && (
        <div className="navegacion-pdf">
            <button 
                disabled={pageNumber <= 1} 
                onClick={() => setPageNumber(p => Math.max(p - 1, 1))}
                title="Página Anterior" /* Añadido para accesibilidad (hover) */
            >
                &larr; {/* Flecha izquierda: &#8592; o &larr; */}
            </button>
            <button 
                disabled={pageNumber >= numPages}
                onClick={() => setPageNumber(p => Math.min(p + 1, numPages))}
                title="Página Siguiente" /* Añadido para accesibilidad (hover) */
            >
                &rarr; {/* Flecha derecha: &#8594; o &rarr; */}
            </button>
        </div>  
      )}

      </div>
    </div>
  );
};

export default TestimonioCard;